module.exports = "<span [countTo]=count></span> ";